import type { GridBlockPosition, GridRow, OverlapValidationResult } from './grid-types';

/**
 * Check if two half-open column ranges [start1, end1) and [start2, end2) overlap
 */
export function rangesOverlap(start1: number, end1: number, start2: number, end2: number): boolean {
	return start1 < end2 && end1 > start2;
}

/**
 * Check if two blocks overlap in the same row
 */
export function blocksOverlap(pos1: GridBlockPosition, pos2: GridBlockPosition): boolean {
	if (pos1.rowIndex !== pos2.rowIndex) return false;
	return rangesOverlap(pos1.colStart, pos1.colStart + pos1.colSpan, pos2.colStart, pos2.colStart + pos2.colSpan);
}

/**
 * Validate an entire positions map to ensure no overlaps exist
 */
export function validateNoOverlaps(
	positions: Record<string, GridBlockPosition>,
	rows: Array<GridRow>,
): OverlapValidationResult {
	const entries = Object.entries(positions);

	for (let i = 0; i < entries.length; i++) {
		const [id1, pos1] = entries[i]!;

		if (pos1.colStart < 0 || pos1.colSpan < 1) {
			return { valid: false, conflictingIds: [id1, id1] };
		}

		const row = rows[pos1.rowIndex];

		if (!row || pos1.colStart + pos1.colSpan > row.columns) {
			return { valid: false, conflictingIds: [id1, id1] };
		}

		for (let j = i + 1; j < entries.length; j++) {
			const [id2, pos2] = entries[j]!;

			if (blocksOverlap(pos1, pos2)) {
				return { valid: false, conflictingIds: [id1, id2] };
			}
		}
	}

	return { valid: true };
}
